import React, { useState } from "react";
import './lags.css';
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import LagsForm from "./lags-form";
import Swal from "sweetalert2";
import axios from 'axios';

function Lags () {
    const [view, setView] = useState('input');
    const [error, setError] = useState('');
    const [flight, setFlight] = useState('');
    const [year, setYear] = useState(new Date().getFullYear().toString());
    const [flightData, setFlightData] = useState(null);
    const [allData, setAllData] = useState(null);
    
    const formatFlight = (value) => {
        const regex = /^([A-Z]{2})(\d{1,4})\/(\d{2})([A-Z]{3})$/i;
        const match = value.toUpperCase().match(regex);

        if (!match) return value.toUpperCase(); // si no matchea, solo convierte a mayúsculas

        const [, airline, number, day, month] = match;
        const paddedNumber = number.padStart(4, '0');
        return `${airline}${paddedNumber}/${day}${month.toUpperCase()}`;
    };

    const handleInputChange = (e) => {
        const input = e.target.value;
        const formatted = formatFlight(input);
        setFlight(formatted);

        if (error) setError('');
    };

    const generateYears = () => {
        const startYear = 2019;
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;
        const years = [];

        for (let y = startYear; y <= nextYear; y++) {
            years.push(y.toString());
        }

        return years;
    };

    const handleYearChange = (e) => {
        setYear(e.target.value);
    };

    const handleSearch = async () => {
        if (!flight.trim()) { 
            setError("Este campo es obligatorio");
            return;
        }
        // const cargo = foundFlight?.cargo || [];
        let foundFlight = false;
        try{
            const res = await axios.post(
                `${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_lags/getFlight`,
                {flight, year},
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                }
            );
            if (res.data.code == 1) {
                foundFlight = true;
                setFlightData(res.data.data.exp_flight);
                setAllData(res.data.data);
            }else{
                foundFlight = false;
            }

        }catch(error){
            foundFlight = false;
            Swal.fire("Error", "Error. Intente nuevamente", "error");
        }
                
        if (!foundFlight) {
            Swal.fire({
                title: "",
                html: `
                    <div style="background-color: #020C41; color: white; padding: 10px; font-size: 1rem; font-weight: bold; text-align: left">
                        Error
                    </div>
                    <div style="padding: 10px;">
                    <div class="alert alert-danger text-start">
                        <p>Por favor revisa el formulario en busca de errores.</p>
                        <ul>
                            <li>El vuelo no existe o no tiene salida.</li>
                        </ul>
                    </div>
                `,
            });
        } else {
            setView('lagsForm');
        }
    };

    return(
        <>
            <Helmet>
                <title>Horus | Rezagos</title>
            </Helmet>
            <ScrollToTop />

            <div className="container-fluid">
                {view === 'input' && (
                <div className="row justify-content-center">
                    <div className="col-3">
                        <label for="inputMaster" class="amc-label">Vuelo</label>
                        <input 
                            type="text"
                            class="form-control"
                            id="name_flight"
                            value={flight}
                            onChange={handleInputChange}
                        />
                        {error && <small className="text-danger">{error}</small>}
                    </div>
                    <div className="col-3">
                        <label for="inputSelect" class="amc-label">Año</label>
                        <select 
                            className="form-select" 
                            name="year" 
                            id="year"
                            value={year}
                            onChange={handleYearChange}
                        >
                            {generateYears().map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                </option>
                            ))}
                        </select>

                        <div className="btns mt-3 d-flex justify-content-end gap-3">
                            <button className='btnn' onClick={handleSearch} >Buscar</button>
                        </div>
                    </div>
                </div>
                )}

                {view === 'lagsForm' && <LagsForm flightData={flightData} allData={allData} />}
            </div>
        </>
    );
}

export default Lags;